module.exports = __webpack_public_path__ + "mobile/img/about-img1.8adfb82c.png";